module.exports = __webpack_public_path__ + "img/logo_white.8e5761e4.svg";